"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const filter_1 = require("./node/expression/filter");
const callable_wrapper_1 = require("./callable-wrapper");
let merge = require('merge');
class TwingFilter extends callable_wrapper_1.TwingCallableWrapper {
    constructor(name, callable, options = {}) {
        super(name, callable);
        this.methodArguments = [];
        this.options = merge({
            'needs_environment': false,
            'needs_context': false,
            'needs_source': false,
            'is_variadic': false,
            'is_safe': null,
            'is_safe_callback': null,
            'pre_escape': null,
            'preserves_safety': null,
            'expression_factory': function (node, filterName, methodArguments, lineno, columnno, tag = null) {
                return new filter_1.TwingNodeExpressionFilter(node, filterName, methodArguments, lineno, columnno, tag);
            },
            'deprecated': false,
            'alternative': null,
        }, options);
    }
    /**
     *
     * @returns {Function}
     */
    getExpressionFactory() {
        return this.options.expression_factory;
    }
    setArguments(someArguments) {
        this.methodArguments = someArguments;
    }
    getArguments() {
        return this.methodArguments;
    }
    needsEnvironment() {
        return this.options.needs_environment;
    }
    needsContext() {
        return this.options.needs_context;
    }
    needsSource() {
        return this.options.needs_source;
    }
    /**
     *
     * @param {TwingNode} filterArgs
     * @returns boolean
     */
    getSafe(filterArgs) {
        if (this.options.is_safe) {
            return this.options.is_safe;
        }
        if (this.options.is_safe_callback) {
            return this.options.is_safe_callback.call(this, filterArgs);
        }
    }
    getPreservesSafety() {
        return this.options.preserves_safety;
    }
    getPreEscape() {
        return this.options.pre_escape;
    }
    isVariadic() {
        return this.options.is_variadic;
    }
    isDeprecated() {
        return this.options.deprecated;
    }
    /**
     *
     * @returns {string}
     */
    getDeprecatedVersion() {
        return this.options.deprecated;
    }
    /**
     *
     * @returns {TwingFilter}
     */
    getAlternative() {
        return this.options.alternative;
    }
}
exports.TwingFilter = TwingFilter;
